var React = require('react');

function MenuFacility (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"パス_1225","d":"M68,8.3,63.6.7h2.5l3,5.5,3-5.5h2.4L70.1,8.3v5.1H68ZM56.5,2.7H53.1V.7h9v2H58.7V13.4H56.6L56.5,2.7ZM48.8.7h2.1V13.3H48.8ZM38.9.7H41V11.5h5.5v2H38.8L38.9.7ZM33.7.7h2.1V13.3H33.7ZM21.6,7.1h0C21.6,3.2,24,.5,27.4.5a5.737,5.737,0,0,1,4.1,1.6L30.2,3.7a5.025,5.025,0,0,0-2.8-1.2c-2,0-3.6,1.8-3.6,4.5v.1c0,2.7,1.5,4.5,3.6,4.5a3.7,3.7,0,0,0,2.9-1.4l1.3,1.5a5.6,5.6,0,0,1-4.2,1.8c-3.4,0-5.8-2.5-5.8-6.4Zm-5,1.4L14.8,3.4,13,8.5ZM13.8.6h2.1l4.8,12.7H18.5l-1.1-3h-5l-1.1,3H9ZM.5.7H8.6v2h-6V6.2H7.9v2H2.6v5.3H.5Z","transform":"translate(-0.5 -0.5)","fill":"#22304a"}));
}

MenuFacility.defaultProps = {"width":"74","height":"13","viewBox":"0 0 74 13"};

module.exports = MenuFacility;

MenuFacility.default = MenuFacility;
